/**
 * Packing List Section
 * Cargo Description field
 */

import { TextArea } from '@/components/base/textarea/textarea';
import type { ContainerFormData } from '@/hooks/useContainerForm';
import { useTranslation } from 'react-i18next';

interface PackingListSectionProps {
    formData: ContainerFormData;
    onInputChange: (field: keyof ContainerFormData, value: string) => void;
}

export function PackingListSection({
    formData,
    onInputChange,
}: PackingListSectionProps) {
    const { t } = useTranslation('pages:containers');

    return (
        <div className="rounded-xl bg-primary p-6 shadow-xs ring-1 ring-secondary">
            <h2 className="text-lg font-semibold text-primary mb-6">{t('form.sections.packingList', 'Packing List Info')}</h2>
            <TextArea
                label={t('form.fields.cargoDescription', 'Cargo Description')}
                placeholder={t('form.fields.cargoDescriptionPlaceholder', 'Describe the cargo contents...')}
                value={formData.cargoDescription}
                onChange={(value) => onInputChange('cargoDescription', value)}
            />
        </div>
    );
}
